import React, { useEffect, useState } from "react";
import { WifiOff, RefreshCw, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link as TanstackLink } from "@tanstack/react-router";

export default function OfflineHandler({ homePath }: { homePath: string }) {
  const [, setIsOnline] = useState(window.navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <>
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
        <Card className="max-w-md w-full mx-4 shadow-2xl border border-gray-200 dark:border-gray-700">
          <CardContent className="p-8 flex flex-col items-center justify-center text-center">
            <div className="bg-red-100 dark:bg-red-900/20 p-4 rounded-full mb-6">
              <WifiOff className="w-8 h-8 text-red-600 dark:text-red-400" />
            </div>

            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
              You're offline
            </h2>

            <p className="text-gray-600 dark:text-gray-300 text-base leading-relaxed mb-8 max-w-sm">
              It looks like you've lost your internet connection. Please check
              your network settings and try again.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 w-full">
              <Button
                onClick={handleRefresh}
                className="flex items-center justify-center gap-2"
                size="lg"
              >
                <RefreshCw className="w-4 h-4" />
                Try again
              </Button>

              <Button
                variant="outline"
                size="lg"
                className="flex items-center justify-center gap-2"
                asChild
              >
                <TanstackLink to={homePath}>
                  <Home className="w-4 h-4" />
                  Go to Home
                </TanstackLink>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
}
